/**
 * PostHog custom event tracking — Shopify (theme: bohopana)
 *
 * Dimuat dari layout/theme.liquid, SESUDAH window.phThemeData didefinisikan.
 * File ini read-only terhadap DOM theme: cuma nempel listener + baca atribut,
 * tidak pernah mengubah markup, class, atau alur cart yang sudah ada.
 */
(function () {
    "use strict";

    // Util dasar
    function capture(name, props) {
      try {
        if (typeof posthog !== "undefined" && posthog && typeof posthog.capture === "function") {
          posthog.capture(name, props || {});
        }
      } catch (e) {}
    }

    function getThemeData() {
      return (window && window.phThemeData) || {};
    }

    var firedOnce = {};
    function once(key, fn) {
      if (!firedOnce[key]) {
        firedOnce[key] = true;
        fn();
      }
    }

    function toNumber(v) {
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }

    function text(el) {
      return el ? (el.textContent || "").trim() : "";
    }

    function currency() {
      return getThemeData().currency || "IDR";
    }

    function pageType() {
      return getThemeData().pageType || "other";
    }

    // Key localStorage buat nandain "browser ini pernah di-identify sebagai
    // customer tertentu" — dipakai buat deteksi logout di page load berikutnya
    // (posthog nggak otomatis tau kalau visitor-nya udah logout).
    var IDENTIFIED_FLAG_KEY = "ph_identified_customer_id";

    function identifyCustomer() {
      var customer = getThemeData().customer;
      if (customer && customer.id) {
        var wasIdentifiedAs = null;
        try { wasIdentifiedAs = localStorage.getItem(IDENTIFIED_FLAG_KEY); } catch (e) {}
        once("identify_user", function () {
          try {
            if (typeof posthog !== "undefined" && posthog && typeof posthog.identify === "function") {
              posthog.identify(String(customer.id), {
                email: customer.email,
                name: customer.name
              });
              // Cuma fire user_logged_in pas transisi ke status login (browser
              // ini belum pernah di-identify sebagai customer ini) — bukan
              // tiap pageview selagi masih login.
              if (wasIdentifiedAs !== String(customer.id)) {
                capture("user_logged_in", {
                  customer_id: customer.id,
                  email: customer.email
                });
              }
              try { localStorage.setItem(IDENTIFIED_FLAG_KEY, String(customer.id)); } catch (e) {}
            }
          } catch (e) {}
        });
      } else {
        // Customer null di page ini. Kalau browser ini sebelumnya pernah
        // di-identify, berarti barusan logout — reset supaya distinct_id
        // baru dipakai dan nggak lanjut ke-atribusi ke akun lama.
        try {
          if (localStorage.getItem(IDENTIFIED_FLAG_KEY)) {
            localStorage.removeItem(IDENTIFIED_FLAG_KEY);
            if (typeof posthog !== "undefined" && posthog && typeof posthog.reset === "function") {
              posthog.reset();
            }
          }
        } catch (e) {}
      }
    }

    // $pageview dikirim manual (theme.liquid set capture_pageview: false)
    // supaya bisa bawa page_type / product context.
    function firePageview() {
      once("pageview", function () {
        var data = getThemeData();
        var props = {
          path: window.location.pathname + window.location.search,
          referrer: document.referrer || "",
          page_type: pageType()
        };
        if (data.pageType === "product" && data.product) {
          props.product_id = data.product.id;
          props.product_name = data.product.title;
          props.category = data.product.type;
          props.price = toNumber(data.product.price);
          props.currency = currency();
        }
        if (data.pageType === "collection" && data.collection) {
          props.collection_id = data.collection.id;
          props.collection_name = data.collection.title;
        }
        capture("$pageview", props);
      });
    }

    // ---------------------------------------------------------------------
    // search_performed
    // ---------------------------------------------------------------------

    function fireSearch() {
      var data = getThemeData();
      if (data.pageType !== "search") return;
      once("search_performed", function () {
        var params = new URLSearchParams(window.location.search);
        capture("search_performed", {
          query: params.get("q") || "",
          results_count:
            typeof data.searchResultsCount === "number" ? data.searchResultsCount : null
        });
      });
    }

    // ---------------------------------------------------------------------
    // variant_selected
    //
    // Dua tempat variant picker di theme ini, markup-nya beda:
    //   1. PDP  -> .pdp-swatch / .pdp-pill (sections/product.liquid).
    //      Catatan: blok warna .pdp-option--color-header ada DI LUAR
    //      {% form 'product' %}, jadi jangan pernah syaratkan closest('form').
    //   2. Variant popup di product card -> .variant-popup__swatch /
    //      .variant-popup__pill, digenerate assets/product-card.js dan tidak
    //      dibungkus <form> sama sekali.
    // ---------------------------------------------------------------------

    var VARIANT_BTN_SELECTOR =
      ".pdp-swatch, .pdp-pill, .variant-popup__swatch, .variant-popup__pill";

    // Trigger quick-add terakhir yang diklik (tombol pembuka variant popup).
    // Dipakai buat tau popup yang lagi kebuka itu produk apa.
    var lastVpTrigger = null;

    function getOptionName(btn) {
      // Popup: product-card.js menaruh nama opsi di data-opt-name.
      var fromData = btn.getAttribute("data-opt-name");
      if (fromData) return fromData;

      // PDP: ambil dari .pdp-option__label, buang bagian nilai terpilih.
      var optionWrap = btn.closest(".pdp-option");
      var label = optionWrap ? optionWrap.querySelector(".pdp-option__label") : null;
      if (!label) return "";
      var clone = label.cloneNode(true);
      var selected = clone.querySelector(".pdp-option__selected");
      if (selected) selected.parentNode.removeChild(selected);
      return clone.textContent.replace(":", "").trim();
    }

    function getOptionValueLabel(btn) {
      // data-label dipasang di .pdp-swatch dan .variant-popup__swatch.
      if (btn.hasAttribute("data-label")) return btn.getAttribute("data-label");
      // Swatch dari snippet product-swatches menyimpan nama warna di sini.
      if (btn.hasAttribute("data-color-name")) return btn.getAttribute("data-color-name");

      // Pill (PDP & popup) labelnya = teks tombol.
      var label = text(btn);
      if (label) return label;

      var val = btn.getAttribute("data-opt-val") || "";
      // Format "HEXCODE_Nama Warna" -> ambil nama warnanya saja.
      return val.indexOf("_") !== -1 ? val.split("_").slice(1).join("_") : val;
    }

    // Produk mana yang sedang dipilih variannya.
    function resolveVariantContext(btn) {
      if (btn.closest(".variant-popup")) {
        var popup = btn.closest(".variant-popup");
        return {
          source_section: "variant_popup",
          product_id: lastVpTrigger ? lastVpTrigger.getAttribute("data-vp-id") || "" : "",
          product_name:
            (lastVpTrigger && lastVpTrigger.getAttribute("data-vp-product-title")) ||
            text(popup.querySelector("[data-vp-title]"))
        };
      }
      var data = getThemeData();
      return {
        source_section: data.pageType === "product" ? "pdp" : "archive",
        product_id: (data.product && data.product.id) || "",
        product_name: (data.product && data.product.title) || ""
      };
    }

    function bindVariantSelect() {
      document.addEventListener("click", function (e) {
        var btn = e.target.closest(VARIANT_BTN_SELECTOR);
        if (!btn) return;
        var ctx = resolveVariantContext(btn);
        capture("variant_selected", {
          product_id: ctx.product_id,
          product_name: ctx.product_name,
          option_name: getOptionName(btn),
          variant_name: getOptionValueLabel(btn),
          source_section: ctx.source_section,
          page_type: pageType()
        });
      });
    }

    // ---------------------------------------------------------------------
    // Network hook (dipakai add-to-cart + sinkronisasi state cart)
    // ---------------------------------------------------------------------

    var cartHandlers = [];

    function registerCartHandler(matchStr, onResponse) {
      cartHandlers.push({ match: matchStr, onResponse: onResponse });
    }

    function matchesAnyHandler(url) {
      for (var i = 0; i < cartHandlers.length; i++) {
        if (url.indexOf(cartHandlers[i].match) !== -1) return true;
      }
      return false;
    }

    function runHandlers(url, reqBody, resJson) {
      for (var i = 0; i < cartHandlers.length; i++) {
        if (url.indexOf(cartHandlers[i].match) !== -1) {
          try {
            cartHandlers[i].onResponse(reqBody, resJson, url);
          } catch (e) {}
        }
      }
    }

    function patchNetwork() {
      var origFetch = window.fetch;
      if (typeof origFetch === "function") {
        window.fetch = function (input, init) {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          var reqBody = (init && init.body) || null;
          var result = origFetch.apply(window, arguments);
          // Hanya clone+parse response yang memang kita amati. Cart page
          // banyak fetch section HTML yang besar — jangan ikut di-parse.
          if (matchesAnyHandler(url)) {
            result
              .then(function (res) {
                return res
                  .clone()
                  .json()
                  .then(function (json) {
                    runHandlers(url, reqBody, json);
                  });
              })
              .catch(function () {});
          }
          return result;
        };
      }

      var XHR = window.XMLHttpRequest;
      if (!XHR || !XHR.prototype) return;
      var origOpen = XHR.prototype.open;
      var origSend = XHR.prototype.send;
      XHR.prototype.open = function (method, url) {
        this._phUrl = String(url || "");
        return origOpen.apply(this, arguments);
      };
      XHR.prototype.send = function (body) {
        var xhr = this;
        var url = xhr._phUrl || "";
        if (matchesAnyHandler(url)) {
          xhr.addEventListener("load", function () {
            try {
              runHandlers(url, body, JSON.parse(xhr.responseText));
            } catch (e) {}
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    // Snapshot cart terbaru dari response /cart/*.js, supaya checkout_started
    // tetap akurat setelah user ubah qty (cart page refresh via AJAX, bukan
    // reload penuh, jadi phThemeData.cart bisa basi).
    var latestCart = null;

    function bindCartStateSync() {
      function absorb(reqBody, resJson) {
        if (resJson && typeof resJson.item_count === "number") {
          latestCart = resJson;
        }
      }
      registerCartHandler("/cart.js", absorb);
      registerCartHandler("/cart/update", absorb);
      registerCartHandler("/cart/change", absorb);
    }

    function cartSnapshot() {
      if (latestCart) {
        return {
          total_price: toNumber(latestCart.total_price) / 100,
          item_count: latestCart.item_count
        };
      }
      var cart = getThemeData().cart;
      return {
        total_price: cart ? toNumber(cart.total_price) : null,
        item_count: cart ? cart.item_count : null
      };
    }

    // ---------------------------------------------------------------------
    // product_added_to_cart
    //
    // Semua placement ATC (tombol PDP, variant popup, quick-add di product
    // card) sama-sama manggil fetch('/cart/add.js', ...) — jadi cukup satu
    // network hook. Listener klik di bawah cuma nyimpen KONTEKS tombol yang
    // diklik (biar source_section akurat), bukan trigger tersendiri.
    // ---------------------------------------------------------------------

    var lastAtcSource = null;

    function resolveAtcSource(btn) {
      if (btn.hasAttribute("data-pdp-atc")) return "pdp";
      if (btn.hasAttribute("data-vp-atc")) return "variant_popup";
      if (btn.closest(".pdp-ymal")) return "you_may_also_like";
      if (btn.closest(".featured-products")) return "featured_products";
      var type = pageType();
      if (type === "search") return "search";
      if (type === "collection") return "collection";
      if (type === "cart") return "cart_recommendation";
      return "archive";
    }

    function bindAtcSourceTracking() {
      document.addEventListener("click", function (e) {
        var trigger = e.target.closest("[data-vp-open]");
        if (trigger) lastVpTrigger = trigger;

        var btn = e.target.closest("[data-pdp-atc], [data-vp-atc], [data-atc-id]");
        if (!btn) return;
        lastAtcSource = resolveAtcSource(btn);
      });
    }

    // Free gift di cart page ditambahkan otomatis oleh sections/cart.liquid
    // lewat /cart/add.js juga. Itu bukan aksi user, jadi jangan dihitung.
    function freebieVariantId() {
      var bar = document.querySelector(".cart-freebie[data-freebie-variant-id]");
      return bar ? (bar.getAttribute("data-freebie-variant-id") || "").trim() : "";
    }

    function isAutoFreeGift(item) {
      if (lastAtcSource) return false; // ada klik ATC user -> bukan auto
      var freebie = freebieVariantId();
      if (!freebie) return false;
      return String(item.variant_id || item.id || "") === freebie;
    }

    function bindAddToCart() {
      registerCartHandler("/cart/add", function (reqBody, resJson) {
        var items = resJson && resJson.items
          ? resJson.items
          : resJson && resJson.id
            ? [resJson]
            : [];
        var source = lastAtcSource || (pageType() === "product" ? "pdp" : "archive");
        items.forEach(function (item) {
          if (isAutoFreeGift(item)) return;
          capture("product_added_to_cart", {
            product_id: item.product_id,
            variant_id: item.variant_id || item.id,
            product_name: item.product_title || item.title,
            category: item.product_type || "",
            variant: item.variant_title || "",
            price: toNumber(item.price) / 100,
            quantity: item.quantity,
            currency: currency(),
            page_type: pageType(),
            source_section: source
          });
        });
        lastAtcSource = null;
      });
    }

    // ---------------------------------------------------------------------
    // product_removed_from_cart
    //
    // Cart page TIDAK submit form. Semua perubahan qty lewat AJAX
    // (sections/cart.liquid -> updateCartQuantity). Ada 3 jalur yang bisa
    // bikin qty jadi 0:
    //   1. klik link "Hapus"        -> [data-cart-remove-line]
    //   2. klik minus saat qty == 1 -> [data-cart-qty-minus]
    //   3. ketik 0 di input qty     -> change pada [data-cart-qty-input]
    // Semua listener di bawah pakai capture phase + passive supaya tidak
    // pernah ikut campur ke handler cart.liquid.
    // ---------------------------------------------------------------------

    function bindCartRemove() {
      var lastRemoved = {};

      function rowQty(row) {
        var input = row.querySelector("[data-cart-qty-input]");
        return input ? parseInt(input.value, 10) || 0 : 0;
      }

      function captureRemoval(row, qty) {
        // Dedupe: satu row cuma boleh sekali dalam 1 detik, jaga-jaga kalau
        // dua jalur kebetulan kepicu bersamaan.
        var key = row.getAttribute("data-key") || row.getAttribute("data-line") || "";
        var now = new Date().getTime();
        if (lastRemoved[key] && now - lastRemoved[key] < 1000) return;
        lastRemoved[key] = now;

        var variants = [];
        row.querySelectorAll(".cart-item__option").forEach(function (el) {
          var v = text(el);
          if (v) variants.push(v);
        });

        capture("product_removed_from_cart", {
          product_id: row.getAttribute("data-product-id") || "",
          variant_id: row.getAttribute("data-variant-id") || "",
          product_name: text(row.querySelector(".cart-item__title")),
          variant: variants.join(" / "),
          price: toNumber(row.getAttribute("data-price")) / 100,
          quantity: qty || 1,
          is_free_gift: row.getAttribute("data-free-gift") === "true",
          currency: currency(),
          page_type: pageType(),
          source_section: "cart"
        });
      }

      document.addEventListener(
        "click",
        function (e) {
          var target = e.target;
          if (!target || !target.closest) return;

          // Jalur 1 — link "Hapus".
          var removeLink = target.closest("[data-cart-remove-line]");
          if (removeLink) {
            var removeRow = removeLink.closest(".cart-item");
            if (removeRow) captureRemoval(removeRow, rowQty(removeRow));
            return;
          }

          // Jalur 2 — minus saat qty tinggal 1.
          var minus = target.closest("[data-cart-qty-minus]");
          if (!minus || minus.disabled) return;
          var minusRow = minus.closest(".cart-item");
          if (!minusRow) return;
          if (rowQty(minusRow) !== 1) return;
          captureRemoval(minusRow, 1);
        },
        true
      );

      // Jalur 3 — qty diketik jadi 0.
      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (!input || !input.matches || !input.matches("[data-cart-qty-input]")) return;
          var qty = parseInt(input.value, 10);
          if (!(isNaN(qty) || qty <= 0)) return;
          var row = input.closest(".cart-item");
          if (!row) return;
          captureRemoval(row, 1);
        },
        true
      );
    }

    // ---------------------------------------------------------------------
    // checkout_started — tombol checkout di cart page
    // ---------------------------------------------------------------------

    function bindCheckoutStarted() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest(
          'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]'
        );
        if (!el || el.disabled) return;
        if (pageType() !== "cart") return;
        var cart = cartSnapshot();
        capture("checkout_started", {
          cart_total: cart.total_price,
          item_count: cart.item_count,
          currency: currency()
        });
      });
    }

    // ---------------------------------------------------------------------
    // whatsapp_clicked — #floating-whatsapp-button
    // ---------------------------------------------------------------------

    function bindWhatsappClick() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest("#floating-whatsapp-button");
        if (!el) return;
        var link = el.querySelector("a");
        capture("whatsapp_clicked", {
          page: window.location.pathname,
          page_type: pageType(),
          link_url: link ? link.getAttribute("href") : ""
        });
      });
    }

    // ---------------------------------------------------------------------
    // banner_clicked
    //
    // Container banner ada 4, dan letak atributnya BEDA:
    //   - .hero-slider__slide (hero-banner)  -> atribut di CONTAINER.
    //     Sengaja bukan di <img>, karena gambar desktop & mobile beda,
    //     slide bisa tanpa gambar (placeholder), dan tombol CTA ada di
    //     luar <picture>.
    //   - .cc-card, .dc-card, .new-in-banner -> atribut di <img> di dalamnya.
    // Makanya dicari di container dulu, baru turun ke keturunannya.
    // ---------------------------------------------------------------------

    var BANNER_SELECTOR =
      ".hero-slider__slide, .cc-card, .dc-card, .new-in-banner";
    var BANNER_ATTR_SELECTOR = "[data-banner-name], [data-banner-category]";

    function getBannerAttrSource(container) {
      if (container.matches && container.matches(BANNER_ATTR_SELECTOR)) return container;
      return container.querySelector(BANNER_ATTR_SELECTOR);
    }

    // Satu slide bisa punya lebih dari satu <a> (gambar dibungkus link +
    // tombol CTA). Pakai link yang benar-benar diklik supaya href-nya akurat,
    // baru jatuh ke link container / link pertama di dalamnya.
    function getBannerLink(container, target) {
      var clicked = target && target.closest ? target.closest("a") : null;
      if (clicked && container.contains(clicked)) return clicked;
      return container.closest("a") || container.querySelector("a");
    }

    function bindBannerClick() {
      document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var container = e.target.closest(BANNER_SELECTOR);
        if (!container) return;
        var source = getBannerAttrSource(container);
        if (!source) return;
        var link = getBannerLink(container, e.target);
        capture("banner_clicked", {
          banner_name: source.getAttribute("data-banner-name") || "",
          banner_category: source.getAttribute("data-banner-category") || "",
          link_url: link ? link.getAttribute("href") : "",
          page: window.location.pathname,
          page_type: pageType()
        });
      });
    }

    // ---------------------------------------------------------------------
    // social_link_clicked
    // ---------------------------------------------------------------------

    function bindSocialLinkClick() {
      document.addEventListener("click", function (e) {
        var link = e.target.closest(".footer-social__link");
        if (!link) return;
        capture("social_link_clicked", {
          platform: link.getAttribute("aria-label") || "",
          link_url: link.getAttribute("href") || "",
          page: window.location.pathname,
          page_type: pageType()
        });
      });
    }

    // ---------------------------------------------------------------------
    // Event custom general, contoh implementasi:
    //      <a href="..." data-ph-event="custom_event_name"
    //         data-ph-props='{"page":"product"}'>Klik</a>
    // ---------------------------------------------------------------------

    function bindCustomDataEvents() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest("[data-ph-event]");
        if (!el) return;
        var name = el.getAttribute("data-ph-event");
        var propsAttr = el.getAttribute("data-ph-props");
        var props = {};
        if (propsAttr) {
          try {
            props = JSON.parse(propsAttr);
          } catch (err) {}
        }
        props.page = window.location.pathname;
        props.page_type = pageType();
        capture(name, props);
      });
    }

    // ---------------------------------------------------------------------
    // Bootstrap
    // ---------------------------------------------------------------------

    function init() {
      bindCartStateSync();
      bindAddToCart();
      patchNetwork();
      identifyCustomer();
      firePageview();
      fireSearch();
      bindVariantSelect();
      bindAtcSourceTracking();
      bindCartRemove();
      bindCheckoutStarted();
      bindWhatsappClick();
      bindBannerClick();
      bindSocialLinkClick();
      bindCustomDataEvents();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
